import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class PartnerProfileBusinessType extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select business type'
        {...this.props}
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
      >
        <Option value='multi-family-building'>Multi-family Building</Option>
        <Option value='co-working-space'>Co-working Space</Option>
        <Option value='multi-functional-building'>Multi-functional Building</Option>
        <Option value='shopping-mall'>Shopping Mall</Option>
        <Option value='others'>Others</Option>
      </Select>
    )
  }
}

export default PartnerProfileBusinessType
